import state from './moduleInvoiceState.js'
import mutations from './moduleInvoiceMutations.js'
import actions from './moduleInvoiceActions.js'
import getters from './moduleInvoiceGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
